import { render } from "./List.vue?vue&type=template&id=d85e8dc2&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=d85e8dc2&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
import "./List.vue?vue&type=style&index=2&id=d85e8dc2&scoped=true&lang=css"

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85e8dc2"]])

export default __exports__